import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import { TextInput } from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGetLocationsPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/locations/get-locations-paginated.form-validation';
import { GetLocationsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/locations/get-locations-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EmspBoLocationCpoFilterController } from '../../../emsp-bo-location-cpo-filter/emsp-bo-location-cpo-filter.controller';

// Fragment CPO ////////////////////////////////////////////////////////////////

const EmspBoLocationListFilterFormStep1CpoFragment = (): React.JSX.Element => {
  const { control } = useFormContext<GetLocationsPaginatedModel>();
  const { cpoId } = useGetLocationsPaginatedFormValidation();

  return (
    <>
      <Controller
        name="cpoId"
        control={control}
        rules={cpoId}
        render={({ field }) => (
          <EmspBoLocationCpoFilterController
            value={field.value || undefined}
            onChange={(value) => field.onChange(value)}
          />
        )}
      />
      <Divider />
    </>
  );
};

// Fragment Country ////////////////////////////////////////////////////////////

const EmspBoLocationListFilterFormStep1CountryFragment =
  (): React.JSX.Element => {
    const { t } = useTranslation();
    const { control } = useFormContext<GetLocationsPaginatedModel>();
    const { country } = useGetLocationsPaginatedFormValidation();

    return (
      <>
        <Controller
          name="country"
          control={control}
          rules={country}
          render={({ field }) => (
            <Stack direction="column" gap={GapEnum.S}>
              <IconText
                iconName="globe-02"
                text={t('$.emsp-bo-location-list-filter.country-label')}
              />
              <TextInput
                value={field.value ?? ''}
                placeholder={t(
                  '$.emsp-bo-location-list-filter.country-placeholder',
                )}
                onChange={(e) => field.onChange(e.target.value || undefined)}
              />
            </Stack>
          )}
        />
        <Divider />
      </>
    );
  };

// Fragment City ///////////////////////////////////////////////////////////////

const EmspBoLocationListFilterFormStep1CityFragment = (): React.JSX.Element => {
  const { t } = useTranslation();
  const { control } = useFormContext<GetLocationsPaginatedModel>();
  const { city } = useGetLocationsPaginatedFormValidation();

  return (
    <>
      <Controller
        name="city"
        control={control}
        rules={city}
        render={({ field }) => (
          <Stack direction="column" gap={GapEnum.S}>
            <IconText
              iconName="building-02"
              text={t('$.emsp-bo-location-list-filter.city-label')}
            />
            <TextInput
              value={field.value ?? ''}
              placeholder={t('$.emsp-bo-location-list-filter.city-placeholder')}
              onChange={(e) => field.onChange(e.target.value || undefined)}
            />
          </Stack>
        )}
      />
      <Divider />
    </>
  );
};

// Fragment Name ///////////////////////////////////////////////////////////////

const EmspBoLocationListFilterFormStep1NameFragment = (): React.JSX.Element => {
  const { t } = useTranslation();
  const { control } = useFormContext<GetLocationsPaginatedModel>();
  const { name } = useGetLocationsPaginatedFormValidation();

  return (
    <Controller
      name="name"
      control={control}
      rules={name}
      render={({ field }) => (
        <Stack direction="column" gap={GapEnum.S}>
          <IconText
            iconName="location"
            text={t('$.emsp-bo-location-list-filter.name-label')}
          />
          <TextInput
            value={field.value ?? ''}
            placeholder={t('$.emsp-bo-location-list-filter.name-placeholder')}
            onChange={(e) => field.onChange(e.target.value || undefined)}
          />
        </Stack>
      )}
    />
  );
};

// Root ////////////////////////////////////////////////////////////////////////

export const EmspBoLocationListFilterFormStep1Controller =
  (): React.JSX.Element => (
    <Stack
      direction="row"
      justifyContent="stretch"
      alignItems="stretch"
      flex={1}
      gap={GapEnum.M}>
      <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.M}>
        <EmspBoLocationListFilterFormStep1CpoFragment />
        <EmspBoLocationListFilterFormStep1CountryFragment />
        <EmspBoLocationListFilterFormStep1CityFragment />
        <EmspBoLocationListFilterFormStep1NameFragment />
      </Stack>
    </Stack>
  );
